(function () {
  var retryCount = 0;
  var maxRetries = 20;

  function shouldPreserveSelectedVariant() {
    return new URLSearchParams(window.location.search).get('find_in_store') === '1';
  }

  function syncVariantOptions(form, variant) {
    variant.options.forEach(function (optionValue, index) {
      var optionName = 'option' + (index + 1);
      var inputs = form.querySelectorAll('[data-option="' + optionName + '"]');

      inputs.forEach(function (input) {
        if (input.tagName === 'SELECT') {
          Array.from(input.options).forEach(function (option) {
            var isSelected = option.value === optionValue;
            option.selected = isSelected;
            option.toggleAttribute('selected', isSelected);
          });
          input.value = optionValue;
          return;
        }

        if (input.type === 'radio' || input.type === 'checkbox') {
          var isChecked = input.value === optionValue;
          input.checked = isChecked;
          input.toggleAttribute('checked', isChecked);
        }
      });
    });
  }

  function applyFirstAvailableVariant(form, variants, variantInput) {
    if (shouldPreserveSelectedVariant()) {
      return false;
    }

    var selectedVariant = variants.find(function (variant) {
      return String(variant.id) === String(variantInput.value);
    });

    if (!selectedVariant || selectedVariant.available) {
      return false;
    }

    var firstAvailableVariant = variants.find(function (variant) {
      return variant.available;
    });

    if (!firstAvailableVariant) {
      return false;
    }

    syncVariantOptions(form, firstAvailableVariant);
    form.querySelectorAll('[data-selected-variant]').forEach(function (selectedVariantElement) {
      selectedVariantElement.textContent = JSON.stringify(firstAvailableVariant);
    });
    variantInput.value = firstAvailableVariant.id;

    if (form.dataset.enableHistoryState === 'true') {
      var currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('variant', firstAvailableVariant.id);
      window.history.replaceState({}, '', currentUrl.href);
    }

    var notifyVariantChange = function () {
      window.setTimeout(function () {
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }, 0);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', notifyVariantChange, { once: true });
    } else {
      notifyVariantChange();
    }

    return true;
  }

  function init() {
    var forms = document.querySelectorAll('[data-js-product-form]');
    if (!forms.length) {
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(init, 500);
      }
      return;
    }

    forms.forEach(function (form) {
      var variantInput = form.querySelector('input[name="id"]');
      var jsonEl = form.querySelector('[data-js-product-json]');
      if (!variantInput || !jsonEl) {
        return;
      }

      var productData;
      try {
        productData = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      var variants = productData.variants || [];

      if (form.dataset.variantFormUpdateInitialized === 'true') {
        return;
      }

      form.dataset.variantFormUpdateInitialized = 'true';

      function getSelectedOptions() {
        var selected = {};
        form.querySelectorAll('[data-option]').forEach(function (input) {
          var key = input.getAttribute('data-option');
          if (input.tagName === 'SELECT') {
            selected[key] = input.value;
          } else if ((input.type === 'radio' || input.type === 'checkbox') && input.checked) {
            selected[key] = input.value;
          }
        });
        return selected;
      }

      function findVariant(selected) {
        return variants.find(function (variant) {
          return Object.keys(selected).every(function (key) {
            var pos = key.replace('option', '');
            return variant['option' + pos] === selected[key];
          });
        });
      }

      function update() {
        var selected = getSelectedOptions();
        var variant = findVariant(selected);
        if (variant) {
          variantInput.value = variant.id;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      form.addEventListener('change', function (event) {
        if (!event.target || !event.target.matches('[data-option]')) {
          return;
        }

        update();
      });

      if (!applyFirstAvailableVariant(form, variants, variantInput)) {
        update();
      }
    });
  }

  init();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }

  document.addEventListener('shopify:section:load', init);
})();
